class HandloomScrollText {
    constructor(section) {
        this.section = section;
        this.container = section.querySelector('.handloom-scroll-text__content');
        this.chunks = Array.from(section.querySelectorAll('.df-scrolltext__chunk'));
        this.isEnabled = this.section.dataset.enableAnimation === 'true';
        this.accentMode = this.section.dataset.accentMode || 'current'; // 'current' or 'all'

        if (!this.isEnabled || this.chunks.length === 0) return;

        this.onScroll = this.onScroll.bind(this);
        this.init();
    }

    init() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        // Initial calculation
        this.onScroll();
    }

    destroy() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
        if (!this.container) return;

        requestAnimationFrame(() => {
            const viewportHeight = window.innerHeight;
            const centerLine = viewportHeight / 2;

            this.chunks.forEach(chunk => {
                const rect = chunk.getBoundingClientRect();
                const chunkCenter = rect.top + (rect.height / 2);

                // Logic:
                // Revealed if the chunk's top is "above" a threshold (e.g., entered the viewport well enough)
                // Or strictly if it's visible. Let's say revealed if it's passed the bottom 10% of screen approx,
                // but for "reading" flow, usually we want it to reveal as it comes near center.
                // Let's match requirement: "progressively change color... as user scrolls down".

                // Simple approach: 
                // 1. Reveal (black) if chunk has entered the "reading zone" (e.g. top < 80% viewport).
                // 2. Current (accent) if it is the closest to the vertical center.

                const isVisible = rect.top < (viewportHeight * 0.85) && rect.bottom > 0;

                if (isVisible) {
                    chunk.classList.add('is-revealed');
                } else {
                    chunk.classList.remove('is-revealed');
                    chunk.classList.remove('is-current');
                }
            });

            // Determine "Current" chunk (closest to center)
            let closestChunk = null;
            let minDistance = Infinity;

            this.chunks.forEach(chunk => {
                if (!chunk.classList.contains('is-revealed')) return;

                const rect = chunk.getBoundingClientRect();
                const chunkCenter = rect.top + (rect.height / 2);
                const distance = Math.abs(centerLine - chunkCenter);

                if (distance < minDistance) {
                    minDistance = distance;
                    closestChunk = chunk;
                }
            });

            // Reset current class
            this.chunks.forEach(c => c.classList.remove('is-current'));

            if (closestChunk) {
                if (this.accentMode === 'all_revealed') {
                    // Alternative mode where all revealed are accent? Req said "current chunk only" usually
                }
                closestChunk.classList.add('is-current');
            }
        });
    }
}

// Init Function
// Init Function
function initHandloomScrollText() {
    const sections = document.querySelectorAll('.handloom-scroll-text');
    sections.forEach(el => {
        // Prevent double init
        if (el.dataset.initialized === 'true') return;
        new HandloomScrollText(el);
        el.dataset.initialized = 'true';
    });
}

// Load on DOM Ready
document.addEventListener('DOMContentLoaded', initHandloomScrollText);

// Theme Editor Support
document.addEventListener('shopify:section:load', (event) => {
    // The event.target is the section wrapper. We need to find our inner container.
    const inner = event.target.querySelector('.handloom-scroll-text');
    if (inner) {
        new HandloomScrollText(inner);
        inner.dataset.initialized = 'true';
    }
});
